import {
  Alert,
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Switch,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import useStyles from "./style";
import BlueInfoSvg from "../../../../components/Svgs/BlueInfoSvg";
import { useEffect, useState } from "react";
import { twoFactorSettings } from "../../../../services";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import SetupTwoFactorModal from "../../../../components/SetupTwoFactorModal";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";

const Security = () => {
  // const { state } = useLocation();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [twoFA, setTwoFA] = useState({
    sms: false,
    email: false,
  });
  const [is2FaAccess, setIs2FaAccess] = useState(false);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  const is2faEnabled = profile?.user?.twoFactorVerified;
  const [
    setupTwoFactorModalOpened,
    { open: setupTwoFactorModalOpen, close: setupTwoFactorModalClose },
  ] = useDisclosure(false);

  // ✅ Fetch current 2FA preferences on mount
  useEffect(() => {
    setTwoFA({
      sms: !!profile?.user?.sms2FaEnabled,
      email: !!profile?.user?.email2FaEnabled,
    });
    setIs2FaAccess(!!profile?.user?.is2FaAccess);
  }, [profile]);
  // useEffect(() => {
  //   if (state?.reset2fa) {
  //     setupTwoFactorModalOpen();
  //   }
  // }, [state?.reset2fa]);

  // ✅ Handle checkbox toggle
  const handleChange = (key) => {
    if (key === "sms") {
      if (profile?.user?.phone === null || profile?.user?.phone === "" || !profile?.user?.phone) {
        swal(
          "Phone Number Not Found",
          "Please set your phone number first from reset button.",
          "error"
        );
        return;
      }
    }
    setTwoFA((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // ✅ Handle save click
  const handleSave = async () => {
    if (!twoFA.sms && !twoFA.email) {
      swal(
        "Error",
        "At least one authentication method (SMS or Email) must be enabled.",
        "error"
      );
      return;
    }
    try {
      setSaving(true);
      const payload = {
        sms2FaEnabled: twoFA?.sms,
        email2FaEnabled: twoFA?.email,
        is2FaAccess: is2FaAccess,
      };
      const res = await twoFactorSettings(payload);
      swal("Success", `${res?.data?.message}`, "success");
    } catch (err) {
      console.error("Error updating 2FA settings:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate("/home/dashboard");
  };
  return (
    <Box>
      {!profile?.user?.twoFactorVerified && (
        <Alert
          color="red"
          title="Two-Factor Authentication"
          variant="light"
          icon={<IconInfoCircle />}
          mb="md"
        >
          Setup 2FA to secure your account
        </Alert>
      )}
      <h2 className={classes.hdng}>Multi Factor Authentication</h2>
      <Flex className={classes.infoBox}>
        <BlueInfoSvg />
        <Text>
          Skypoint saves sensitive health information. To protect your clients
          and stay compliant, we require an extra step to verify your identity
          when logging in.
        </Text>
      </Flex>
      <Box className={classes.content}>
        <Box className={classes.optionsParent}>
          {profile?.user?.role !== "staff" && (
            <Flex className={classes.option}>
              <Box>
                <Text fw={600}>Enable Two-Factor Authentication</Text>
                <Text size="sm" color="dimmed">
                  Require an extra verification step during login
                </Text>
              </Box>
              <Switch
                checked={is2FaAccess}
                onChange={(event) => {
                  const checked = event.currentTarget.checked;
                  if (checked && !is2faEnabled) {
                    swal(
                      "Verification Required",
                      "Please verify your 2FA first before enabling it.",
                      "warning"
                    );
                    return;
                  }
                  setIs2FaAccess(checked);
                }}
                color="yellow"
                size="md"
              />
            </Flex>
          )}
          <Flex className={classes.option}>
            <Box>
              <Text className="title">SMS</Text>
              <Text className="discription">
                Use your mobile phone to receive a text message with an
                authentication code
              </Text>
              {profile?.user?.phone && (
                <Flex gap={20} align="center">
                  <Text className="data">{profile?.user?.phone}</Text>
                  {profile?.user?.isPhoneVerified ? (
                    <Badge variant="light" color="green">Verified</Badge>
                  ) : (
                    <Badge variant="light" color="red">Not Verified</Badge>
                  )}
                </Flex>
              )}
            </Box>
            <Flex align="center" gap={20}>
              <Checkbox
                checked={twoFA?.sms}
                onChange={() => handleChange("sms")}
              />
              <UnstyledButton
                className={classes.resetBtn}
                onClick={setupTwoFactorModalOpen}
              >
                Reset
              </UnstyledButton>
            </Flex>
          </Flex>
          <Flex className={classes.option}>
            <Box>
              <Text className="title">Email</Text>
              <Text className="discription">
                Use your email to receive a message with an authentication code
              </Text>

              <Text className="data">{profile?.user?.email}</Text>
            </Box>
            <Flex align="center" gap={20}>
              <Checkbox
                checked={twoFA?.email}
                onChange={() => handleChange("email")}
              />
              <UnstyledButton
                style={{ visibility: "hidden" }}
                className={classes.resetBtn}
              >
                Reset
              </UnstyledButton>
            </Flex>
          </Flex>
        </Box>
        <Flex className={classes.bottom}>
          <Button className={classes.cancelBtn} onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className={classes.saveBtn}
            loading={saving}
            onClick={handleSave}
          >
            {saving ? "Saving..." : "Save"}
          </Button>
        </Flex>
      </Box>

      <SetupTwoFactorModal
        opened={setupTwoFactorModalOpened}
        close={setupTwoFactorModalClose}
        profile={profile}
        isSettingPage={true}
      />
    </Box>
  );
};

export default Security;
